import React from 'react';
import { useOpenAccount } from '../../../../ApexOPL/AccountOpening/hooks/useOpenAccount';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';

interface Props {
  clientId: string;
}

export const OpenNewAccountButton: React.FC<Props> = ({ clientId }) => {
  const { isLoading, canOpenAccount, onOpenAccount } = useOpenAccount({ clientId });

  if (!canOpenAccount) {
    return null;
  }

  return (
    <Button
      variant="secondary"
      size="large"
      isLoading={isLoading}
      disabled={isLoading}
      onClick={() => onOpenAccount()}
    >
      Open New Account
    </Button>
  );
};
